<template>
  <div class="wallet-title">{{ text }}</div>
</template>

<script>
export default {
  data() {
    return {
      text: ""
    };
  },
  watch: {
  //   $route() {
  //     this.upText();
  //   }
  },
  methods: {
    upText() {
if (this.$route.path == "/about") this.text = "About us";

else this.text=this.$route.path.replace("/","")
      //如果是首字母是w就w大写
      if (this.text == "wallet"||this.text == "account") {
        //首字母大写
        this.text = this.text.replace(this.text.charAt(0), this.text.charAt(0).toUpperCase());
      }
    }
  },
  mounted() {
    this.upText();
  }
};
</script>

<style scoped>
.wallet-title {
  z-index: 99;
  position: fixed;
  left: 0;
  top: 0;
  color: #fff;
  height: 70px;
  line-height: 70px;
  text-align: center;
  background-color:#a95159 ;
  background: linear-gradient(183deg, #a95159, #a95159);
  width: 100%;
  font-size: 30px;
}
img{
  cursor: pointer;
}
</style>
